function configureSelect2WithAutocomplete($config, $ajaxRequestOnSelect, $nameFunctionOnSelect, $nameFunctionUnSelect){
    $('select[' + $config.attrElement + '="' + $config.nameElement + '"]').select2({
        language: "pt-BR",
        width: '100%',
        placeholder: {
            id: '', // the value of the option
            text: ''
        },
        dropdownParent: $config.elementDropDownParent,
        allowClear: true,
        ajax: {
            url: $config.url,
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    descricao: params.term
                };
            },
            processResults: function (data, params) {
                params.page = params.page || 1;

                return {
                    results: data,
                };
            },
            cache: true
        },
        escapeMarkup: function (markup) {
            return markup;
        },
        minimumInputLength: ($config.minimumInputLength || 3 ),
        templateResult: formatRepo,
        templateSelection: formatRepoSelection,
    }).on("select2:select", function (e) {
        if (!e) {
            var args = "{}";
        } else {
            var args = JSON.stringify(e.params, function (key, value) {
                if (value && value.nodeName) return "[DOM node]";
                if (value instanceof $.Event) return "[$.Event]";
                return value;
            });

            if ($ajaxRequestOnSelect){
                window[$nameFunctionOnSelect](e);
            }
        }
    }).on("select2:unselect", function (e) {
        $('select[' + $config.attrElement + '="' + $config.nameElement + '"]').find('option[value="' + e.params.data.id + '"]').remove();
        window[$nameFunctionUnSelect](e);
    });
};

function formatRepo(repo) {
    if (repo.loading) return repo.text;

    var markup = "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" + repo.text + "</div>";

    markup += "<div class='select2-result-repository__statistics'>" +
        "</div>" +
        "</div>" +
        "</div>";

    return markup;
}

function formatRepoSelection(repo) {
    return repo.text || repo.id;
}

/********************************* FUNCTIONS ONSELECT ***********************************************/
function getClienteUsuarios(event){
    jQuery.get('/cadastro/cliente/getclienteusuario/' + event.params.data.id, function ($json) {
        $('select[name="cliente_usuario"]').prop('disabled', true);
        var $usuario = $('select[name="cliente_usuario"]');
        $usuario.find('option').remove();
        if ($json['status']) {
            $('select[name="cliente_usuario"]').prop('disabled', false);

            $.each($json['data'], function (key, value) {
                $('<option>').val(key).text(value).appendTo($usuario);
            });
        }
        else{
            toastr.warning('Nenhum usuário cadastrado para esse distribuidor!');
        }
    });
}

function removeSelectionClienteUsuarios(event){
    var $usuario = jQuery('select[name="cliente_usuario"]');
    $usuario.find('option').remove();
    $usuario.prop('disabled', true);
}

function getPrecoCaixa(event){
    debugger;
    var $cliente = document.getElementsByName('cliente')[0].value,
        $material = event.params.data.id,
        $aValor = JSON.parse($('input[name="objeto_valor"]').val());

    jQuery.post('/cadastro/material/precocaixa', {cliente: $cliente, material: $material}, function($json){
       if ($json.status){
           debugger;
           document.getElementsByName('preco_caixa')[0].value = $json.preco;

           var $inputTipoManutencao = $('input[name="tipo_manutencao"]:checked').val();
           var $inputCobrarPecas = $('input[name="cobrar_pecas"]:checked').val();
           var $inputManutencao = $('input[name="valor_manutencao"]');
           if ($inputManutencao.length && $inputTipoManutencao == 0) {
               var $qtd = 1;
               var $valorMaterial = $json.preco;
               var $valorOrcamento = ($inputManutencao.val() == '' ? 0 : parseFloat($inputManutencao.val().replace('.', '').replace(',', '.')));

               for (var $i = 0; $i < $aValor.length; $i++) {
                   if ($material == $aValor[$i].id) {
                       if ($valorOrcamento > 0 && $valorOrcamento >= $valorMaterial) {
                           $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($aValor[$i].quantidade) * parseFloat($aValor[$i].valor)));
                       }

                       $aValor.splice($i, 1);
                   }
               }

               if ($valorMaterial !== '' && $valorMaterial !== 0 && $qtd !== '' && $qtd !== 0) {
                   $valorOrcamento = (parseFloat($valorOrcamento) + (parseFloat($qtd) * parseFloat($valorMaterial)));

                   $aValor.push({
                       id: $material,
                       quantidade: $qtd,
                       valor: $valorMaterial,
                       tipo: 'pecas'
                   });

                   if ($inputCobrarPecas === '0' && $name['input'].indexOf('pecas') !== -1) {
                       $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($qtd) * parseFloat($valorMaterial)));
                   }
               }

               $inputManutencao.val(numberToReal($valorOrcamento));
               $('input[name="objeto_valor"]').val(JSON.stringify($aValor));
           }
       }
       else{
           $aValor.push({
               id: $material,
               quantidade: 1,
               valor: 0,
               tipo: 'pecas'
           });
           $('input[name="objeto_valor"]').val(JSON.stringify($aValor));
       }
    });
}

function removeSelectionPrecoCaixa(event){
    var $element = jQuery('select[name="material_caixa"]');
    var $valorMaterial = parseFloat($('input[name="preco_caixa"]').val());
    var $aValor = JSON.parse($('input[name="objeto_valor"]').val());
    var $inputManutencao = $('input[name="valor_manutencao"]');
    var $valorOrcamento = ($inputManutencao.val() == '' ? 0 : parseFloat($inputManutencao.val().replace('.', '').replace(',', '.')));

    for (var $i = 0; $i < $aValor.length; $i++) {
        if (event.params.data.id == $aValor[$i].id) {
            if ($valorOrcamento > 0 && $valorOrcamento >= $valorMaterial) {
                $valorOrcamento = (parseFloat($valorOrcamento) - (parseFloat($aValor[$i].quantidade) * parseFloat($aValor[$i].valor)));
            }

            $aValor.splice($i, 1);
        }
    }

    $inputManutencao.val(numberToReal($valorOrcamento));
    $('input[name="objeto_valor"]').val(JSON.stringify($aValor));

    $element.find('option').remove();
}